/**
 * @generated SignedSource<<051378caadcd782d6244190eecfc5368>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type ZakekeEnvironment = "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
export type productSidePanelContent_ProductQuery$variables = {
  id: string;
};
export type productSidePanelContent_ProductQuery$data = {
  readonly node: {
    readonly additionalCodes?: ReadonlyArray<{
      readonly code: string;
      readonly merchantProductName: string;
      readonly salesChannel: {
        readonly detail: {
          readonly id: string;
          readonly properties: {
            readonly name: string | null;
          } | null;
        } | null;
        readonly ecommerceSettings: {
          readonly definitiveUrl: string | null;
          readonly ecommerceName: ECommerce;
          readonly hasProductsApi: boolean;
          readonly productsApi: string | null;
          readonly remoteUrl: string | null;
        } | null;
        readonly id: string;
      };
      readonly salesChannelID: string;
    }>;
    readonly areaBackgroundRules?: {
      readonly productRule: {
        readonly colorList: string | null;
      } | null;
    } | null;
    readonly canAddAdditionalCode?: boolean;
    readonly code?: string;
    readonly id?: string;
    readonly modelColorsCompressed?: string;
    readonly modelID?: number;
    readonly moqRules?: {
      readonly productRule: {
        readonly id: string;
        readonly moqRuleID: number;
        readonly name: string;
      } | null;
    } | null;
    readonly name?: string;
    readonly printingMethods?: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly printTypeID: number;
      readonly restrictions: {
        readonly showImageProvider: boolean | null;
        readonly uploadRestrictions: {
          readonly isUserImageAllowed: boolean | null;
        } | null;
      } | null;
    }>;
    readonly provider?: ProductProvider;
    readonly quoteRule?: {
      readonly id: string;
      readonly name: string | null;
      readonly quoteRuleID: number;
    } | null;
    readonly salesChannel?: {
      readonly detail: {
        readonly id: string;
        readonly properties: {
          readonly name: string | null;
        } | null;
      } | null;
      readonly ecommerceSettings: {
        readonly definitiveUrl: string | null;
        readonly ecommerceName: ECommerce;
        readonly hasProductsApi: boolean;
        readonly productsApi: string | null;
        readonly remoteUrl: string | null;
      } | null;
      readonly id: string;
    };
    readonly scenes?: ReadonlyArray<{
      readonly sceneID: any;
    }>;
    readonly smallImageUrl?: string;
    readonly sourceProductTemplateID?: number | null;
    readonly statusID?: number;
    readonly zakekeEnvironment?: ZakekeEnvironment;
  } | null;
};
export type productSidePanelContent_ProductQuery = {
  response: productSidePanelContent_ProductQuery$data;
  variables: productSidePanelContent_ProductQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modelID",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusID",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "smallImageUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zakekeEnvironment",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canAddAdditionalCode",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceProductTemplateID",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modelColorsCompressed",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannelDetail",
  "kind": "LinkedField",
  "name": "detail",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesChannelDetailProperties",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteUrl",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productsApi",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasProductsApi",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitiveUrl",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannel",
  "kind": "LinkedField",
  "name": "salesChannel",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EcommerceSettings",
      "kind": "LinkedField",
      "name": "ecommerceSettings",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesChannelID",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merchantProductName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "PrintType",
  "kind": "LinkedField",
  "name": "printingMethods",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "printTypeID",
      "storageKey": null
    },
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PartPrintTypeRestriction",
      "kind": "LinkedField",
      "name": "restrictions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showImageProvider",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UploadRestriction",
          "kind": "LinkedField",
          "name": "uploadRestrictions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isUserImageAllowed",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelScene",
  "kind": "LinkedField",
  "name": "scenes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sceneID",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorList",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "QuoteRule",
  "kind": "LinkedField",
  "name": "quoteRule",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quoteRuleID",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "MoqRules",
  "kind": "LinkedField",
  "name": "moqRules",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MoqRule",
      "kind": "LinkedField",
      "name": "productRule",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "moqRuleID",
          "storageKey": null
        },
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannel",
  "kind": "LinkedField",
  "name": "salesChannel",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EcommerceSettings",
      "kind": "LinkedField",
      "name": "ecommerceSettings",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_ProductQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductCode",
                "kind": "LinkedField",
                "name": "additionalCodes",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              (v22/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AreaBackgroundRules",
                "kind": "LinkedField",
                "name": "areaBackgroundRules",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AreaBackgroundRule",
                    "kind": "LinkedField",
                    "name": "productRule",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v25/*: any*/),
              (v26/*: any*/)
            ],
            "type": "Model",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "productSidePanelContent_ProductQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductCode",
                "kind": "LinkedField",
                "name": "additionalCodes",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v27/*: any*/)
                ],
                "storageKey": null
              },
              (v22/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AreaBackgroundRules",
                "kind": "LinkedField",
                "name": "areaBackgroundRules",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AreaBackgroundRule",
                    "kind": "LinkedField",
                    "name": "productRule",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v25/*: any*/),
              (v26/*: any*/)
            ],
            "type": "Model",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9ef5fbbb82b803e8afc5548c53628ec5",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_ProductQuery",
    "operationKind": "query",
    "text": "query productSidePanelContent_ProductQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Model {\n      id\n      modelID\n      name\n      code\n      statusID\n      smallImageUrl\n      zakekeEnvironment\n      provider\n      canAddAdditionalCode\n      sourceProductTemplateID\n      modelColorsCompressed\n      salesChannel {\n        id\n        detail {\n          id\n          properties {\n            name\n          }\n        }\n        ecommerceSettings {\n          ecommerceName\n          remoteUrl\n          productsApi\n          hasProductsApi\n          definitiveUrl\n          id\n        }\n      }\n      additionalCodes {\n        code\n        salesChannelID\n        merchantProductName\n        salesChannel {\n          id\n          detail {\n            id\n            properties {\n              name\n            }\n          }\n          ecommerceSettings {\n            ecommerceName\n            remoteUrl\n            productsApi\n            hasProductsApi\n            definitiveUrl\n            id\n          }\n        }\n      }\n      printingMethods {\n        id\n        printTypeID\n        name\n        restrictions {\n          showImageProvider\n          uploadRestrictions {\n            isUserImageAllowed\n          }\n        }\n      }\n      scenes {\n        sceneID\n      }\n      areaBackgroundRules {\n        productRule {\n          colorList\n          id\n        }\n      }\n      quoteRule {\n        id\n        quoteRuleID\n        name\n      }\n      moqRules {\n        productRule {\n          id\n          moqRuleID\n          name\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2f861614fc00215465f6571285aa72e0";

export default node;
